import select from './DictItemSelect.vue'
const FormDictItemSelect = {
  install: function (Vue) {
    Vue.component('FormDictItemSelect', select)
  }
}
export default FormDictItemSelect
